import React from 'react'
import { Helmet } from "react-helmet"

const SEO = () => {
    return (
        <div>
            <Helmet>
                <title>Tell Connect - The Open Banking Lite Solution</title>
                <meta name="description" content="The Open Banking Lite Platform, PSD2, API, Connect" />
                <meta name="og:title" property="og:title" content="Tell Connect - The Open Banking Lite Solution"></meta>
                <meta name="twitter:card" content="Tell Connect - The Open Banking Lite Solution"></meta>
               
                
            </Helmet>
        </div>
    )
}

export default SEO
